import useSWR from "swr";
import { getValueExpressions } from "../services/template-service";
import type {
  ValueExpressionsResponse,
  ValueExpressionItem,
} from "../types/api-types";

export interface UseValueExpressionsReturn {
  valueExpressions: ValueExpressionItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: () => void;
}

const useValueExpressions = (
  templateId: number | null,
): UseValueExpressionsReturn => {
  const { data, error, isLoading, mutate } = useSWR<ValueExpressionsResponse>(
    templateId ? `value-expressions-${templateId}` : null,
    () =>
      templateId
        ? getValueExpressions(templateId)
        : Promise.resolve({ results: [] }),
  );

  return {
    valueExpressions: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useValueExpressions;
